import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { TextField, InputLabel } from '@mui/material'

export default function Index({ SelectedDate, handleDateChange, Label, name, variant, className, size, isRequired, value, Error, disabled }) {

    return (
        <>
            <div className={`${className}`}>
                <InputLabel id="" className='fw-6 font-11 blackLight'>{Label}{isRequired && <span className="text-danger"> *</span>}</InputLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDateTimePicker
                        inputFormat="yyyy-MM-ddTHH:mm:ss"
                        value={SelectedDate}
                        onChange={handleDateChange}
                        onBlur={handleDateChange}
                        name={name}
                        size={size}
                        disabled={disabled}
                        disablePortal
                        PopperProps={{
                            modifiers: [
                                {
                                    name: 'preventOverflow',
                                    options: {
                                        boundary: 'viewport', // Ensures the popper stays within the viewport
                                        rootBoundary: 'viewport', // Handles small screen heights
                                    },
                                },
                                {
                                    name: 'offset',
                                    options: {
                                        offset: [0, 10], // Adds vertical spacing to avoid overlap
                                    },
                                },
                            ],
                        }}
                        renderInput={(params) => <TextField variant={variant ? variant : "outlined"}  {...params} />}
                    />
                    {Error && <p className='font-11 ' style={{ color: 'red' }}>{Error}</p>}
                </LocalizationProvider>
            </div>
        </>
    )
}